export type Unpacked<T> = T extends (infer U)[] ? U : T;

export function toSentenceCase(str: string) {
  if (!str) {
    return null;
  }
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
